<template lang="html">
  <div>
    <div class="outlet-selection cursor-pointer" @click="openDialog()">
      <div v-if="!$isEmpty(selected_outlet)" class="flex-image py-2 px-4">
        <div class="mr-2">
          <div class="d-flex">
            <img :src="selected_outlet.logo" alt="Voucher" class="image-40">
          </div>
        </div>
        <div class="flex-image-content">
          <div class="flex-image-content-text ol-black font-14 font-weight-600">
            {{ selected_outlet.name }}
          </div>
          <!-- <div class="flex-image-content-text ol-grey-content font-12 font-weight-400">
            {{ distanceText }}
          </div> -->
        </div>
        <div class="ml-2">
          <v-icon size="24" color="olblack">
            mdi-chevron-down
          </v-icon>
        </div>
      </div>
    </div>
    <v-bottom-sheet v-model="dialog.list_items" content-class="dialog-icon">
      <div class="position-relative">
        <v-btn fab small color="white" class="btn-close-dialog-icon" @click="dialog.list_items = false">
          <v-icon>
            mdi-close
          </v-icon>
        </v-btn>
      </div>
      <v-sheet class="sheet-border">
        <v-container>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <div class="mt-2 font-18 font-weight-700 mb-4">
                {{ $t('v2.chosee_a_outlet') }}
              </div>
              <div class="list-outlet" style="margin-left: -16px; margin-right: -16px; ">
                <template v-for="(item, i) in outlets">
                  <div :key="i" :class="['flex-image py-2 px-4 prevent-select', { 'cursor-pointer': $store.state.selected_outlet.url_id !== item.url_id }]" @click="$store.state.selected_outlet.url_id !== item.url_id && selectOutlet(item)">
                    <div class="mr-2 align-self-center d-flex">
                      <img :src="item.logo" :alt="item.name" class="image-40 br-8">
                    </div>
                    <div class="flex-image-content">
                      <div class="flex-image-content-text ol-black font-14 font-weight-600">
                        {{ item.name }}
                      </div>
                      <div v-if="(typeof item.location_distance !== 'undefined')" class="flex-image-content-text ol-grey-content font-12 font-weight-400">
                        {{ item.location_distance.text }}
                      </div>
                      <div v-else>
                        -
                      </div>
                    </div>
                  </div>
                  <div v-if="i !== (outlets.length - 1)" :key="i + '-line'" class="div-line with-padding-16" />
                </template>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-sheet>
    </v-bottom-sheet>
  </div>
</template>
<script>
import { getData as getDataOutlet } from '@/api/outlet'
export default {
  name: 'OutletSelection',
  props: {
    value: {
      default: '',
      type: [Number, String, Array, Object]
    },
    params: {
      type: Object,
      default: () => ({
        origin_lat: 0,
        origin_lon: 0
      })
    }
  },
  data() {
    return {
      dialog: {
        list_items: false
      },
      outlets: [],
      lastFetch: null
    }
  },
  computed: {
    modelValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    selected_outlet() {
      return this.$store.state.selected_outlet
    },
    distanceText() {
      let textLocation = '-'
      if (this.$store.state.selected_outlet && !this.$isEmpty(this.$store.state.selected_outlet)) {
        const idx = this.outlets.findIndex((e) => {
          return e.id === this.$store.state.selected_outlet.id
        })
        if (typeof this.outlets[idx] !== 'undefined' && typeof this.outlets[idx].location_distance !== 'undefined') {
          textLocation = this.outlets[idx].location_distance.text
        }
      }
      return textLocation
    }
  },
  methods: {
    selectOutlet(item) {
      const selected = {
        id: item.id,
        url_id: item.url_id
      }
      this.$emit('input', selected)
      this.$emit('select-outlet', item)
      this.dialog.list_items = false
    },
    openDialog() {
      this.dialog.list_items = true
      const now = Date.now()
      if (this.outlets.length === 0 || !this.lastFetch || now - this.lastFetch > 5 * 60 * 1000) {
        this.getOutlet()
      }
    },
    async getOutlet() {
      this.lastFetch = Date.now()
      try {
        var data = {}
        if (this.params.origin_lat === 0 && this.params.origin_lon === 0) {
          data = await getDataOutlet()
        } else {
          data = await getDataOutlet(this.params)
        }
        this.outlets = data.data.data
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>
